import { gql } from '@apollo/client'

export const overviewMetadataFragment = gql`
    fragment overviewMetadataFragment on Metadata {
        created
        updated
        modifiedBy {
            profileInfo {
                firstName
                lastName
            }
        }
    }
`
export const ProductFamilyTableViewFragment = gql`
    fragment productFamilyTableViewFragment on ProductFamilyStudioManagment {
        productFamilyId
        name
        familyName
        familyNumber
        publishedDate
        publishedBy
        lastUpdatedDate
        type
        assignedUser
        state
        version
        dateOfIssue
        familyIsDraft
        productFamilyLinkingIds
        ppfId
        projectElementNodeId
        isDivisionViewNode
        workItemState
        workItemAssignedTo
        isSpecTextNode
        itemType
        dashboardUpdateId
    }
`
